/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button, Col, Form, FormGroup, Input, InputGroup, Row, Table } from 'reactstrap';
import { JhiItemCount, JhiPagination, Translate, getPaginationState, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort, faSortDown, faSortUp } from '@fortawesome/free-solid-svg-icons';
import { ASC, DESC, ITEMS_PER_PAGE, SORT } from 'app/shared/util/pagination.constants';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities, searchEntities } from './pharmacy-external-order-shipment.reducer';

export const PharmacyExternalOrderShipment = () => {
  const dispatch = useAppDispatch();

  const pageLocation = useLocation();
  const navigate = useNavigate();

  const [search, setSearch] = useState('');
  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getPaginationState(pageLocation, ITEMS_PER_PAGE, 'id'), pageLocation.search),
  );

  const pharmacyExternalOrderShipmentList = useAppSelector(state => state.pharmacyExternalOrderShipment.entities);
  const loading = useAppSelector(state => state.pharmacyExternalOrderShipment.loading);
  const totalItems = useAppSelector(state => state.pharmacyExternalOrderShipment.totalItems);

  const getAllEntities = () => {
    if (search) {
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    } else {
      dispatch(
        getEntities({
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
  };

  const startSearching = e => {
    if (search) {
      setPaginationState({
        ...paginationState,
        activePage: 1,
      });
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
    e.preventDefault();
  };

  const clear = () => {
    setSearch('');
    setPaginationState({
      ...paginationState,
      activePage: 1,
    });
    dispatch(getEntities({}));
  };

  const handleSearch = event => setSearch(event.target.value);

  const sortEntities = () => {
    getAllEntities();
    const endURL = `?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`;
    if (pageLocation.search !== endURL) {
      navigate(`${pageLocation.pathname}${endURL}`);
    }
  };

  useEffect(() => {
    sortEntities();
  }, [paginationState.activePage, paginationState.order, paginationState.sort, search]);

  useEffect(() => {
    const params = new URLSearchParams(pageLocation.search);
    const page = params.get('page');
    const sort = params.get(SORT);
    if (page && sort) {
      const sortSplit = sort.split(',');
      setPaginationState({
        ...paginationState,
        activePage: +page,
        sort: sortSplit[0],
        order: sortSplit[1],
      });
    }
  }, [pageLocation.search]);

  const sort = p => () => {
    setPaginationState({
      ...paginationState,
      order: paginationState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handlePagination = currentPage =>
    setPaginationState({
      ...paginationState,
      activePage: currentPage,
    });

  const handleSyncList = () => {
    sortEntities();
  };

  const getSortIconByFieldName = (fieldName: string) => {
    const sortFieldName = paginationState.sort;
    const order = paginationState.order;
    if (sortFieldName !== fieldName) {
      return faSort;
    }
    return order === ASC ? faSortUp : faSortDown;
  };

  return (
    <div>
      <h2 id="pharmacy-external-order-shipment-heading" data-cy="PharmacyExternalOrderShipmentHeading">
        <Translate contentKey="tinyMedicRestApp.pharmacyExternalOrderShipment.home.title">Pharmacy External Order Shipments</Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="tinyMedicRestApp.pharmacyExternalOrderShipment.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link
            to="/pharmacy-external-order-shipment/new"
            className="btn btn-primary jh-create-entity"
            id="jh-create-entity"
            data-cy="entityCreateButton"
          >
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="tinyMedicRestApp.pharmacyExternalOrderShipment.home.createLabel">
              Create new Pharmacy External Order Shipment
            </Translate>
          </Link>
        </div>
      </h2>
      <Row>
        <Col sm="12">
          <Form onSubmit={startSearching}>
            <FormGroup>
              <InputGroup>
                <Input
                  type="text"
                  name="search"
                  defaultValue={search}
                  onChange={handleSearch}
                  placeholder={translate('tinyMedicRestApp.pharmacyExternalOrderShipment.home.search')}
                />
                <Button className="input-group-addon">
                  <FontAwesomeIcon icon="search" />
                </Button>
                <Button type="reset" className="input-group-addon" onClick={clear}>
                  <FontAwesomeIcon icon="trash" />
                </Button>
              </InputGroup>
            </FormGroup>
          </Form>
        </Col>
      </Row>
      <div className="table-responsive">
        {pharmacyExternalOrderShipmentList && pharmacyExternalOrderShipmentList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th className="hand" onClick={sort('id')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyExternalOrderShipment.id">Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('id')} />
                </th>
                <th className="hand" onClick={sort('saleBillId')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyExternalOrderShipment.saleBillId">Sale Bill Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('saleBillId')} />
                </th>
                <th className="hand" onClick={sort('purchaseBillId')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyExternalOrderShipment.purchaseBillId">Purchase Bill Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('purchaseBillId')} />
                </th>
                <th className="hand" onClick={sort('refundBillId')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyExternalOrderShipment.refundBillId">Refund Bill Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('refundBillId')} />
                </th>
                <th className="hand" onClick={sort('active')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyExternalOrderShipment.active">Active</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('active')} />
                </th>
                <th className="hand" onClick={sort('cursor')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyExternalOrderShipment.cursor">Cursor</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('cursor')} />
                </th>
                <th className="hand" onClick={sort('lastUpdated')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyExternalOrderShipment.lastUpdated">Last Updated</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('lastUpdated')} />
                </th>
                <th className="hand" onClick={sort('microSec')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyExternalOrderShipment.microSec">Micro Sec</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('microSec')} />
                </th>
                <th className="hand" onClick={sort('timestampEntry')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyExternalOrderShipment.timestampEntry">Timestamp Entry</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('timestampEntry')} />
                </th>
                <th className="hand" onClick={sort('supplierId')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyExternalOrderShipment.supplierId">Supplier Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('supplierId')} />
                </th>
                <th className="hand" onClick={sort('supplierIdType')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyExternalOrderShipment.supplierIdType">Supplier Id Type</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('supplierIdType')} />
                </th>
                <th className="hand" onClick={sort('consumerId')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyExternalOrderShipment.consumerId">Consumer Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('consumerId')} />
                </th>
                <th className="hand" onClick={sort('consumerType')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyExternalOrderShipment.consumerType">Consumer Type</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('consumerType')} />
                </th>
                <th className="hand" onClick={sort('shipmentStatus')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyExternalOrderShipment.shipmentStatus">Shipment Status</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('shipmentStatus')} />
                </th>
                <th className="hand" onClick={sort('consignmentNumber')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyExternalOrderShipment.consignmentNumber">Consignment Number</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('consignmentNumber')} />
                </th>
                <th className="hand" onClick={sort('carrierDetails')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyExternalOrderShipment.carrierDetails">Carrier Details</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('carrierDetails')} />
                </th>
                <th className="hand" onClick={sort('internalShipmentNumber')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyExternalOrderShipment.internalShipmentNumber">
                    Internal Shipment Number
                  </Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('internalShipmentNumber')} />
                </th>
                <th className="hand" onClick={sort('addedById')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyExternalOrderShipment.addedById">Added By Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('addedById')} />
                </th>
                <th className="hand" onClick={sort('modifiedById')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyExternalOrderShipment.modifiedById">Modified By Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('modifiedById')} />
                </th>
                <th className="hand" onClick={sort('addedByType')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyExternalOrderShipment.addedByType">Added By Type</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('addedByType')} />
                </th>
                <th className="hand" onClick={sort('modifiedByType')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyExternalOrderShipment.modifiedByType">Modified By Type</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('modifiedByType')} />
                </th>
                <th className="hand" onClick={sort('billNumber')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyExternalOrderShipment.billNumber">Bill Number</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('billNumber')} />
                </th>
                <th className="hand" onClick={sort('excludeTax')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyExternalOrderShipment.excludeTax">Exclude Tax</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('excludeTax')} />
                </th>
                <th className="hand" onClick={sort('portCode')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyExternalOrderShipment.portCode">Port Code</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('portCode')} />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.pharmacyExternalOrderShipment.order">Order</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.pharmacyExternalOrderShipment.exportType">Export Type</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {pharmacyExternalOrderShipmentList.map((pharmacyExternalOrderShipment, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`/pharmacy-external-order-shipment/${pharmacyExternalOrderShipment.id}`} color="link" size="sm">
                      {pharmacyExternalOrderShipment.id}
                    </Button>
                  </td>
                  <td>{pharmacyExternalOrderShipment.saleBillId}</td>
                  <td>{pharmacyExternalOrderShipment.purchaseBillId}</td>
                  <td>{pharmacyExternalOrderShipment.refundBillId}</td>
                  <td>{pharmacyExternalOrderShipment.active ? 'true' : 'false'}</td>
                  <td>{pharmacyExternalOrderShipment.cursor}</td>
                  <td>{pharmacyExternalOrderShipment.lastUpdated}</td>
                  <td>{pharmacyExternalOrderShipment.microSec}</td>
                  <td>{pharmacyExternalOrderShipment.timestampEntry}</td>
                  <td>{pharmacyExternalOrderShipment.supplierId}</td>
                  <td>
                    <Translate contentKey={`tinyMedicRestApp.SupplierType.${pharmacyExternalOrderShipment.supplierIdType}`} />
                  </td>
                  <td>{pharmacyExternalOrderShipment.consumerId}</td>
                  <td>
                    <Translate contentKey={`tinyMedicRestApp.ConsumerType.${pharmacyExternalOrderShipment.consumerType}`} />
                  </td>
                  <td>
                    <Translate contentKey={`tinyMedicRestApp.ShipmentStatus.${pharmacyExternalOrderShipment.shipmentStatus}`} />
                  </td>
                  <td>{pharmacyExternalOrderShipment.consignmentNumber}</td>
                  <td>{pharmacyExternalOrderShipment.carrierDetails}</td>
                  <td>{pharmacyExternalOrderShipment.internalShipmentNumber}</td>
                  <td>{pharmacyExternalOrderShipment.addedById}</td>
                  <td>{pharmacyExternalOrderShipment.modifiedById}</td>
                  <td>
                    <Translate contentKey={`tinyMedicRestApp.PharmacyAddedByType.${pharmacyExternalOrderShipment.addedByType}`} />
                  </td>
                  <td>
                    <Translate contentKey={`tinyMedicRestApp.PharmacyAddedByType.${pharmacyExternalOrderShipment.modifiedByType}`} />
                  </td>
                  <td>{pharmacyExternalOrderShipment.billNumber}</td>
                  <td>{pharmacyExternalOrderShipment.excludeTax ? 'true' : 'false'}</td>
                  <td>{pharmacyExternalOrderShipment.portCode}</td>
                  <td>
                    {pharmacyExternalOrderShipment.order ? (
                      <Link to={`/pharmacy-external-order/${pharmacyExternalOrderShipment.order.id}`}>
                        {pharmacyExternalOrderShipment.order.id}
                      </Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {pharmacyExternalOrderShipment.exportType ? (
                      <Link to={`/clinical-dictionary/${pharmacyExternalOrderShipment.exportType.id}`}>
                        {pharmacyExternalOrderShipment.exportType.id}
                      </Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button
                        tag={Link}
                        to={`/pharmacy-external-order-shipment/${pharmacyExternalOrderShipment.id}`}
                        color="info"
                        size="sm"
                        data-cy="entityDetailsButton"
                      >
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`/pharmacy-external-order-shipment/${pharmacyExternalOrderShipment.id}/edit?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        onClick={() =>
                          (window.location.href = `/pharmacy-external-order-shipment/${pharmacyExternalOrderShipment.id}/delete?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`)
                        }
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="tinyMedicRestApp.pharmacyExternalOrderShipment.home.notFound">
                No Pharmacy External Order Shipments found
              </Translate>
            </div>
          )
        )}
      </div>
      {totalItems ? (
        <div className={pharmacyExternalOrderShipmentList && pharmacyExternalOrderShipmentList.length > 0 ? '' : 'd-none'}>
          <div className="justify-content-center d-flex">
            <JhiItemCount page={paginationState.activePage} total={totalItems} itemsPerPage={paginationState.itemsPerPage} i18nEnabled />
          </div>
          <div className="justify-content-center d-flex">
            <JhiPagination
              activePage={paginationState.activePage}
              onSelect={handlePagination}
              maxButtons={5}
              itemsPerPage={paginationState.itemsPerPage}
              totalItems={totalItems}
            />
          </div>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export default PharmacyExternalOrderShipment;
